<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/places">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="pronunciation detail_content">
            <div class="pronunciation_label detail_label">
              {{ pronunciationLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('pronunciation')"
            />
          </div>
          <div class="location_name detail_content">
            <div class="user_name_label detail_label">
              {{ userNameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('userName')"
            />
          </div>
          <div class="phone_number detail_content">
            <div class="phone_number_label detail_label">
              {{ phoneNumberLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('phoneNumber')"
            />
          </div>
          <div class="location_address detail_content">
            <div class="location_address_label detail_label">
              {{ locationAddressLabel }}
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('locationAddress')"
            />
          </div>
          <div class="memo_detail_content">
            <div class="memo_label detail_label">
              {{ memoLabel }}
            </div>
            <textarea
              class="detail_input_field memo"
              @input="inputAddUpdate('memo')"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addPlace"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      userIdLabel: '拠点ID',
      pronunciationLabel: 'ふりがな',
      userNameLabel: '拠点名',
      postNameLabel: '所属',
      deviceIdLabel: '端末ID',
      phoneNumberLabel: '電話番号',
      locationAddressLabel: '住所',
      memoLabel: '補足情報',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false
    }
  },
  async created() {
    this.$store.dispatch('places/clearLocation')
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  computed: {
    locations() {
      return this.$store.state.places.locations
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    }
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('places/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/places')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addPlace(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('places/addLocation')
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_350001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) {
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0023') {
            this.failureWord =
              this.errorMsg.MSGCRC0023.name +
              this.errorMsg.MSGCRC0023.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0024') {
            this.failureWord =
              this.errorMsg.MSGCRC0024.name +
              this.errorMsg.MSGCRC0024.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0092') {
            this.failureWord =
              this.errorMsg.MSGCRC0092.name +
              this.errorMsg.MSGCRC0092.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0098') {
            this.failureWord =
              this.errorMsg.MSGCRC0098.name +
              this.errorMsg.MSGCRC0098.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0099') {
            this.failureWord =
              this.errorMsg.MSGCRC0099.name +
              this.errorMsg.MSGCRC0099.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0100') {
            this.failureWord =
              this.errorMsg.MSGCRC0100.name +
              this.errorMsg.MSGCRC0100.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0124') {
            this.failureWord =
              this.errorMsg.MSGCRC0124.name +
              this.errorMsg.MSGCRC0124.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0206') {
            this.failureWord =
              this.errorMsg.MSGCRC0206.name +
              this.errorMsg.MSGCRC0206.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0264') {
            this.failureWord =
              this.errorMsg.MSGCRC0264.name +
              this.errorMsg.MSGCRC0264.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0273') {
            this.failureWord =
              this.errorMsg.MSGCRC0273.name +
              this.errorMsg.MSGCRC0273.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0026.name +
              this.errorMsg.MSGCRC0026.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scope>
.memo {
  resize: vertical;
  min-height: 200px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/places/placeAdd.vue